import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { VisualCompareFileDescriptor } from './visual-compare-file-descriptor';


@Component({
    selector: 'app-visual-compare-file-info',
    templateUrl: './visual-compare-file-info.component.html',
    styleUrls: ['./visual-compare-file-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class VisualCompareFileInfoComponent {
  title = input<string>('');
  file = input.required<VisualCompareFileDescriptor>();
  compareTo = input.required<VisualCompareFileDescriptor>();
  color = input<string>('yellow');

  hiliteContentType(): boolean {
    return this.file() && this.compareTo() && this.file().contentType !== this.compareTo().contentType;
  }

  hiliteEncoding(): boolean {
    return this.file() && this.compareTo() && this.file().encoding !== this.compareTo().encoding;
  }

  hiliteBomPresent(): boolean {
    return this.file() && this.compareTo() && this.file().bomPresent !== this.compareTo().bomPresent;
  }

  hiliteContentLength(): boolean {
    return this.file() && this.compareTo() && (this.file().size) !== (this.compareTo().size);
  }
}
